<div class="offline-popup-wrap" *ngIf="!isConnected">
    <div class="offline-popup">
            <span class="offline-icon"></span>
        <h2> You are currently offline. Kindly connect back to internet.</h2>
    </div>
</div>

<div class="general-popup red" *ngIf="deployment_running && !closeDeploymentMessage">
            <span class="icon-topic-warnning"></span>
        <h2> {{deployment_message}}</h2>
        <i class="icon-cira" (click)="deployment_running = !deployment_running;closeDeploymentMessage = true"></i>
</div>

<router-outlet>
    <div class="loading-overlay" #spinnerElement>
        <!-- loader DOM -->
        <img src="/assets/images/loading.gif" alt="">
    </div>
    <app-long-progress></app-long-progress>
    <app-draggable-popup></app-draggable-popup>
    
</router-outlet>


<!-- Pre load the background image for offline icon -->
<span class="offline-icon" style="display: none;"></span>